module.exports = __webpack_public_path__ + "static/media/07A.543b3861.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/robots/07A.png
// module id = 255
// module chunks = 0